'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'layer-group';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f5fd';
var svgPathData = 'M259.4 48.7L430.8 128 259.4 207.2c-2.1 1-4.6 1-6.7 0L81.2 128 252.6 48.7c2.1-1 4.6-1 6.7 0zM279.5 5.2c-14.9-6.9-32.1-6.9-47 0L13.9 106.2C5.4 110.1 0 118.6 0 128s5.4 17.9 13.9 21.8l218.6 101c14.9 6.9 32.1 6.9 47 0l218.6-101c8.5-3.9 13.9-12.4 13.9-21.8s-5.4-17.9-13.9-21.8L279.5 5.2zM48.1 218.4L13.9 234.2C5.4 238.1 0 246.6 0 256s5.4 17.9 13.9 21.8l218.6 101c14.9 6.9 32.1 6.9 47 0l218.6-101c8.5-3.9 13.9-12.4 13.9-21.8s-5.4-17.9-13.9-21.8l-34.1-15.8-57.2 26.4 24.1 11.1-171.4 79.2c-2.1 1-4.6 1-6.7 0L81.2 256 105.3 244.9 48.1 218.4zM13.9 362.2C5.4 366.1 0 374.6 0 384s5.4 17.9 13.9 21.8l218.6 101c14.9 6.9 32.1 6.9 47 0l218.6-101c8.5-3.9 13.9-12.4 13.9-21.8s-5.4-17.9-13.9-21.8l-34.1-15.8-57.2 26.4 24.1 11.1-171.4 79.2c-2.1 1-4.6 1-6.7 0l-171.4-79.2 24.1-11.1-57.2-26.4-34.1 15.8z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faLayerGroup = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;